<template>
  <div>
    <v-card class="pa-4">
      <v-row no-gutters justify="space-between" align="center">
        <v-col class="font-weight-bold"> Stage of Payment </v-col>
        <v-col cols="auto">
          <v-btn
            v-if="!disabled && !isOneTime"
            fab
            x-small
            color="success"
            @click="addPayment"
          >
            <v-icon>mdi-plus</v-icon>
          </v-btn>
        </v-col>
      </v-row>
      <v-list v-if="paymentType">
        <v-list-item
          v-for="(payment, index) in payments"
          :key="index"
          class="px-0"
        >
          <v-list-item-avatar
            v-if="!isOneTime"
            color="grey"
            class="white--text font-weight-medium"
          >
            {{ index + 1 }}
          </v-list-item-avatar>
          <v-list-item-content>
            <v-row no-gutters>
              <v-col cols="3">
                <v-text-field
                  v-model="payment.percentage"
                  type="number"
                  :disabled="disabled || isOneTime"
                  :filled="disabled"
                  @input="updatePaymentAmount($event, index)"
                  suffix="%"
                  :error="hasErrors"
                  hide-details
                  outlined
                  dense
                ></v-text-field>
                <div
                  v-if="!disabled && payments.length !== 1"
                  class="mt-1 grey--text"
                  title="Amount Suggestion"
                >
                  Amount:
                  <span
                    class="value-setter"
                    @click="setAmount(payment.percentage, index)"
                  >
                    {{ calcAmount(payment.percentage) | toCurrencyWithoutSign }}
                  </span>
                </div>
              </v-col>
              <v-col class="pl-4">
                <v-currency-field
                  v-model="payment.amount"
                  :filled="disabled"
                  @input="updatePaymentPercent($event, index)"
                  :disabled="payment.percentage === 100 || isOneTime"
                  hide-details
                  outlined
                  dense
                ></v-currency-field>
                <div
                  v-if="!disabled && payments.length !== 1"
                  class="mt-1 grey--text"
                  title="Percentage Suggestion"
                >
                  Percentage:
                  <span
                    class="value-setter"
                    @click="setPercentage(payment.amount, index)"
                  >
                    {{ calcPercentage(payment.amount) }} %
                  </span>
                </div>
              </v-col>
            </v-row>
          </v-list-item-content>
          <v-list-item-action v-if="!disabled">
            <v-btn
              v-if="!isOneTime"
              fab
              small
              depressed
              color="error"
              @click="removePayment(index)"
            >
              <v-icon>mdi-delete</v-icon>
            </v-btn>
          </v-list-item-action>
        </v-list-item>
      </v-list>
    </v-card>
  </div>
</template>

<script>
import VCurrencyField from '@/components/VCurrencyField';

// build

export default {
  name: 'PaymentStageField',
  components: {
    VCurrencyField
  },
  props: {
    value: {},
    errors: {
      type: Array,
      default: () => []
    },
    disabled: {
      type: Boolean,
      default: false
    },
    paymentType: {
      type: [String, Number],
      default: 1
    },
    amountOfSupport: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      payments: []
    };
  },
  watch: {
    value: {
      immediate: true,
      handler(val) {
        this.payments = val;
      }
    },
    payments: {
      deep: true,
      handler(val) {
        this.$emit('input', val);
      }
    },
    amountOfSupport() {
      this.payments = this.payments.map(item => ({
        ...item,
        amount: this.calcAmount(item.percentage)
      }));
    }
  },
  computed: {
    isOneTime() {
      return this.paymentType === 1;
    },
    isMultiple() {
      return this.payments.length > 1;
    },
    hasErrors() {
      return this.errors.length > 0;
    }
  },
  methods: {
    // eslint-disable-next-line no-unused-vars
    updatePaymentAmount(event, index) {
      // this.payments[index].amount = this.calcAmount(event);
    },
    // eslint-disable-next-line no-unused-vars
    updatePaymentPercent(event, index) {
      // this.payments[index].percentage = this.calcPercentage(event);
    },
    calcAmount(percentage) {
      return (percentage / 100) * this.amountOfSupport;
    },
    calcPercentage(amount) {
      return (amount / this.amountOfSupport) * 100;
    },
    setAmount(percentage, index) {
      this.payments[index].amount = this.calcAmount(percentage);
    },
    setPercentage(amount, index) {
      this.payments[index].percentage = this.calcPercentage(amount);
    },
    addPayment() {
      this.payments.push({
        percentage: 0,
        amount: 0
      });
    },
    removePayment(index) {
      this.payments.splice(index, 1);
    }
  }
};
</script>

<style scoped lang="scss">
.value-setter {
  cursor: pointer;
  &:hover {
    color: #28a0f6;
    text-decoration: underline;
  }
}
</style>
